<template>
  <div>
    <HeaderPanel
      title="Web Channel Setting"
      placeholder=""
      :hasDropdown="false"
      :hasFilter="false"
      :hasSearch="false"
    />
    <div class="bg-white border-red p-2 p-lg-3 mt-3">
      <b-row class="align-items-center">
        <b-col lg="6" md="6" sm="12" xs="12">
          <b-form-checkbox
            id="is_default"
            name="is_default"
            v-model="form.enable"
            :value="true"
            :unchecked-value="false"
          >
            Enable Web Channel
          </b-form-checkbox>
        </b-col>
      </b-row>
      <div v-if="form.enable">
        <b-row class="mt-3">
          <b-col lg="6" md="6" sm="12" xs="12">
            <InputText
              textFloat="Website URL"
              placeholder="Website URL"
              v-model="form.url"
              isRequired
              type="text"
              :isValidate="$v.form.url.$error"
              :v="$v.form.url"
              class="mb-0"
            />
          </b-col>
          <b-col lg="6" md="6" sm="12" xs="12">
            <InputText
              textFloat="Inactive Time"
              placeholder="Inactive Time"
              v-model="form.inactive_time"
              isRequired
              type="text"
              :isValidate="$v.form.inactive_time.$error"
              :v="$v.form.inactive_time"
              class="mb-0"
              detail="* Unit of Time is Minutes."
            />
          </b-col>
        </b-row>
        <b-row class="align-items-center">
          <b-col lg="8" md="8" sm="12" xs="12">
            <div class="d-flex justify-content-end">
              <button
                type="button"
                class="btn-icon pr-0"
                @click="copyToClipboard"
              >
                <font-awesome-icon icon="copy" />
              </button>
            </div>
            <div class="header-script">
              <pre class="mb-0"><code>{{ form.setting }}</code></pre>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <FooterAction routePath="/setting/web-channel" @submit="checkForm" />
  </div>
</template>

<script>
import { required, requiredIf, url, minValue, numeric } from "vuelidate/lib/validators";
import { getBrandCode } from "@/utils/brand_code.js";

export default {
  components: {},
  data() {
    const brand_code = getBrandCode();
    return {
      id: 0,
      brand_code: brand_code,
      form: {
        id: 0,
        key_id: null,
        brand_code: brand_code,
        enable: false,
        url: null,
        setting: null,
        created_time: "0001-01-01T00:00:00",
        updated_time: "0001-01-01T00:00:00",
        inactive_time: 0,
      },
    };
  },
  validations() {
    return {
      form: {
        url: {
          required: requiredIf((item) => {
            return item.enable;
          }),
          // url,
        },
        inactive_time: {
          required,
          minValue: minValue(0),
          numeric
        }
      },
    };
  },
  async created() {
    this.getData();
  },
  methods: {
    async getData() {
      await this.$store.dispatch(
        "getWebChannelSettingDetail",
        this.form.brand_code
      );
      let data = await this.$store.state.webchannel
        .stateGetWebChannelSettingDetail;
      if (data.result == 1) {
        this.form = data.detail;
        this.id = this.form.id;
        if (this.form.id == 0) {
          this.form.setting = this.getEmbedCode("{{key_id}}");
        } else {
          this.form.setting = this.getEmbedCode(this.form.key_id);
        }
      } else {
        this.errorAlert();
      }
    },
    getEmbedCode(id) {
      const domain_dcom_analytics = `${process.env.VUE_APP_DOMAIN_DCOM_ANALYTICS}`
      let embedCode =
        `<link rel="stylesheet" href="${domain_dcom_analytics}/dcom-analytics.css" />
<script src="${domain_dcom_analytics}/dcom-analytics.umd.js?id=${id}"></scr` +
        `ipt>
<scr` +
        `ipt>
  window.addEventListener('load', function () {
    if (window.DcomAnalytics) {
      window.DcomAnalytics.setConfig({
        id: '${id}',
        member_id: ''
      });

      // window.DcomAnalytics.onLogin({
      //   member_id: ''
      // });

      // window.DcomAnalytics.onRegister({
      //   member_id: ''
      // });

      // window.DcomAnalytics.trackPageView({
      //   member_id: '',
      //   screen_name: ''
      // });

      // window.DcomAnalytics.onLogout();
    }
  });
</scr` +
        `ipt>`;

      return embedCode;
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.form.setting).then(() => {
        this.successAlert("You just copied");
      });
    },
    checkForm: async function () {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      if (!this.form.brand_code) this.form.brand_code = this.brand_code;
      this.modalAlertShow = false;
      this.submit();
    },
    submit: async function () {
      this.$bus.$emit("showLoading");
      this.isDisable = true;
      let data = null;

      if (this.id !== 0) {
        await this.$store.dispatch("updateWebChannelSetting", this.form);
        data = await this.$store.state.webchannel.stateUpdateWebChannelSetting;
        if (data.result == 1) {
          this.successAlert().then(() =>
            this.$router.push("/setting/web-channel")
          );
        }
      } else {
        await this.$store.dispatch("createWebChannelSetting", this.form);
        data = await this.$store.state.webchannel.stateCreateWebChannelSetting;
        if (data.result == 1) {
          this.successAlert().then(() =>
            this.$router.push("/setting/web-channel")
          );
        }
      }
      this.isDisable = false;
      this.$bus.$emit("hideLoading");
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-icon {
  background-color: transparent;
  border: none;
  font-size: 16px;
}
.header-script {
  background-color: #eeeeee;
  color: var(--font-main-color);
  border: 1px solid #d8dbe0;
  border-radius: 0.25rem;
  padding: 0.375rem 0.75rem;
  font-weight: bold;
  font-size: 16px;
}
</style>
